import {Box} from "@mantine/core";
import classes from "./ProtocolTable.module.css"
import commonClasses from "../../../common/common.module.css"
import cx from "clsx";
import {dayjsToMonthDay} from "../../../common/utils/times";
import {useNavigate} from "react-router";
import {DashboardIcons} from "../common/constants";
import {IProtocolDefStats} from "../types/IProtocolDefStats";
import {showGTZero} from "../common/utils";

export interface ProtocolTableProps {
    stats: Array<IProtocolDefStats>
}

export const ProtocolTable: React.FC<ProtocolTableProps> = ({stats}: ProtocolTableProps) => {
    const navigate = useNavigate()


    const renderRows = () => {
        return stats.map((row) => {
            return (
                <Box key={`dr-${row.pdefId}`}
                     className={cx(classes.row, commonClasses.hover, commonClasses.borderHover, commonClasses.sbRadius, commonClasses.tgBorder)}
                     onClick={() => navigate(`/analysis/dashboards/pdef/${row.pdefId}`)}>
                    <Box className={cx(classes.rowTitle)}>
                        <DashboardIcons.templateIcon/>
                        {row.name}
                    </Box>
                    <Box className={cx(classes.rowRow, classes.subText)}>
                        <Box className={cx("ntc-row-component ntc-flex-align-center")}>
                            <Box><DashboardIcons.notesIcon size={"1em"}/></Box>
                            <Box ml="0.25em" mr={"1em"}>{row.sessionCount} Sessions</Box>
                            <Box><DashboardIcons.subjectsIcon size={"1em"}/></Box>
                            <Box ml="0.25em" mr={"1em"}>{row.numUniqueSubjects} Subjects</Box>
                            <Box className={cx(classes.subText, "ntc-row-component ntc-flex-align-center")}>
                                <DashboardIcons.durationIcon size={"1em"}/>
                                <Box ml={"0.25em"}>Last Run</Box><Box
                                ml={"0.25em"}>{row.lastSessionStart ? dayjsToMonthDay(row.lastSessionStart) : ""}</Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box mt="0.5em" className={cx(classes.rowRow)}>
                        {
                            showGTZero(row.stimCount,
                                <Box className={cx(classes.rowMetric)}>
                                    <DashboardIcons.stimulationsIcon size={"1em"}/>
                                    <Box>{row.stimCount}</Box>
                                    Stimulations
                                </Box>
                            )}
                        {
                            showGTZero(row.megScanCount,
                                <Box className={cx(classes.rowMetric)}>
                                    <DashboardIcons.megScanIcon size={"1em"}/>
                                    <Box>{row.megScanCount}</Box>
                                    MEG Scans
                                </Box>
                            )}
                        {
                            showGTZero(row.eegScanCount,
                                <Box className={cx(classes.rowMetric)}>
                                    <DashboardIcons.eegScanIcon size={"1em"}/>
                                    <Box>{row.eegScanCount}</Box>
                                    EEG Scans
                                </Box>
                            )}

                    </Box>

                </Box>
            )
        })
    }
    return (
        <Box className={cx(classes.root, commonClasses.sbRadius)}>
            <Box
                className={cx(classes.header, commonClasses.mediumLightBlueGradient90, commonClasses.stbRadius, commonClasses.tgbBorder)}>
                <Box>Protocols Overview</Box>
                <Box className={classes.subText}>Monitor and Analyse all research Protocols</Box>
            </Box>
            <Box className={cx(classes.rows)}>
                {renderRows()}
            </Box>

        </Box>
    )
}